import React from 'react'

const Home = () => (
  <div>
    <h2> Hello! I'm Dana! </h2>
    <div>
      <p>
        I am a full stack web developer creating high quality web and mobile
        applications. I build dynamic experiences while focusing on user
        experience, performance, and reliability. I love to use programming to
        explore data and answer interesting questions.
      </p>
      <p>
        I currently work as a full stack developer for Major League Baseball at{' '}
        <a href="https://baseballsavant.mlb.com">Baseball Savant</a>.
      </p>
      <p>
        I was born and have lived most of my life in Maine. I currently live
        just outside Portland with my lovely girlfriend. We both like to spend
        time outdoors, which often includes hiking, mountain biking,
        snowboarding, and ultimate frisbee.
      </p>
      <p>
        Previously I've worked for the{' '}
        <a href="https://www.mlb.com/braves">Atlanta baseball team</a>,{' '}
        <a href="https://chess.com">Chess.com</a> and{' '}
        <a href="https://reconnect.io">Reconnect.io</a>
      </p>
    </div>
    <h3>Code</h3>
    <div>
      <ul>
        <li style={{ marginLeft: '1em' }}>
          <a href="https://github.com/danab">GitHub</a> - My day to day work is
          in private repositories, but there are a few interesting public things
          to see here.
        </li>

        <li style={{ marginLeft: '1em' }}>
          <a href="https://codepen.io/danab">CodePen</a> - Occasionally quick
          projects wind up here.
        </li>
      </ul>
    </div>
  </div>
)

export default Home
